import { render, staticRenderFns } from "./sendlist.vue?vue&type=template&id=259dd8d4"
import script from "./sendlist.vue?vue&type=script&lang=js"
export * from "./sendlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports